import { AsyncComponentLoader, Component, defineAsyncComponent } from 'vue';

const CHUNK_LOAD_ERROR =
  /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed/;
const LAST_RELOAD_KEY = 'chunkReloadedAt';
const RELOAD_COOLDOWN_MS = 5 * 60_000;

export function isStaleChunkError(error: Error | undefined): boolean {
  return navigator.onLine && CHUNK_LOAD_ERROR.test(error?.message);
}

function reloadUnlessJustReloaded(): boolean {
  const lastReloadAt = Number(sessionStorage.getItem(LAST_RELOAD_KEY));
  if (Date.now() - lastReloadAt < RELOAD_COOLDOWN_MS) {
    return false;
  }
  sessionStorage.setItem(LAST_RELOAD_KEY, String(Date.now()));
  window.location.reload();
  return true;
}

export function lazyComponent(loader: AsyncComponentLoader): Component {
  return defineAsyncComponent(() =>
    loader().catch((error) => {
      if (isStaleChunkError(error) && reloadUnlessJustReloaded()) {
        return new Promise(() => undefined);
      }
      throw error;
    }),
  );
}
